import { createApp } from 'vue'
import { Loader } from '@googlemaps/js-api-loader';
import { $ } from '@/utils/dom'

export const App = {
  delimiters: ['[[', ']]'],
  data() {
    return {
      confirm: false,
      share: false,
      contact: false,
      notMember: false,
      urlCopied: false
    }
  },
  methods: {
    isSP() {
      return navigator.userAgent.match(/iPhone|Android.+Mobile/)
    },
    openApp() {
        const lat = $('#id_latitude').value
        const lng = $('#id_longitude').value
        window.open(`https://www.google.com/maps/search/?api=1&query=${lat},${lng}`)
    }
  },
  mounted() {
    const loader = new Loader({
      apiKey: 'AIzaSyB2A-iP0nqP6VqLgFP1iXZj2d6Sc2zAo3o',
      version: '3.52',
      libraries: ['places']
    })

    const mapOptions = {
      center: {
        lat: Number($('#id_latitude').value),
        lng: Number($('#id_longitude').value)
      },
      fullscreenControl: false,
      mapTypeControl: false,
      streetViewControl: false,
      zoom: 15
    }

    loader
      .load()
      .then((google) => {
        const map = new google.maps.Map(document.getElementById('map'), mapOptions)
        new google.maps.Marker({
          map: map,
          position: map.center,
          draggable: false,
        });
        $('#map').style.width = '100%'
        $('#map').style.height = '500px'
      })
      .catch(e => {
        console.error(e)
      })
  }
}
if (document.getElementById('app')) {
  createApp(App).mount('#app')
}
